import { render, staticRenderFns } from "./MedIcons.vue?vue&type=template&id=2a8bf6ca&scoped=true&"
import script from "./MedIcons.vue?vue&type=script&lang=js&"
export * from "./MedIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8bf6ca",
  null
  
)

export default component.exports